import { NgModule } from '@angular/core';

//Angular Material

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { GridModule, ExcelModule, PDFModule } from '@progress/kendo-angular-grid';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { NgxPaginationModule } from 'ngx-pagination';
import { DragulaModule } from 'ng2-dragula';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { LabelModule } from '@progress/kendo-angular-label';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { FileUploadModule } from 'primeng/fileupload';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { TabsModule } from 'primeng/tabs';
import { ProgressBarModule } from 'primeng/progressbar';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';

// HIGHCHARTS
import * as Highcharts from 'highcharts';
import Drilldown from 'highcharts/modules/drilldown';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';
import Highmaps from 'highcharts/modules/map';
import Streamgraphs from 'highcharts/modules/streamgraph';
import Funnelgraph from 'highcharts/modules/funnel';
import Heatmap from 'highcharts/modules/heatmap';
import HighchartsGroupedCategories from 'highcharts-grouped-categories/grouped-categories';
import BorderRadius from 'highcharts-border-radius';
import Histogram from 'highcharts/modules/histogram-bellcurve';
// import { AvatarModule } from '@progress/kendo-angular-layout';
import { AvatarModule } from 'ngx-avatars';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { ListboxModule } from 'primeng/listbox';

Drilldown(Highcharts);
HighchartsMore(Highcharts);
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
Highmaps(Highcharts);
Streamgraphs(Highcharts);
Funnelgraph(Highcharts);
Heatmap(Highcharts);
HighchartsGroupedCategories(Highcharts);
BorderRadius(Highcharts);
Histogram(Highcharts);

@NgModule({
    declarations: [],
    exports: [
        AngularMultiSelectModule,
        HttpClientModule,
        FormsModule,
        InputsModule,
        ReactiveFormsModule,
        MatButtonToggleModule,
        // Angular Material
        MatIconModule,
        MatCheckboxModule,
        MatButtonModule,
        MatCardModule,
        MatRadioModule,
        MatListModule,
        MatMenuModule,
        MatRippleModule,
        MatSelectModule,
        MatSliderModule,
        MatSnackBarModule,
        MatDialogModule,
        MatChipsModule,
        MatInputModule,
        MatDividerModule,
        MatGridListModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatAutocompleteModule,
        MatExpansionModule,
        MatSidenavModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        GridModule,
        TooltipModule,
        ExcelModule,
        DateInputsModule,
        PDFModule,
        NgxPaginationModule,
        DropDownsModule,
        DragulaModule,
        CurrencyMaskModule,
        AvatarModule,
        ButtonModule,
        MultiSelectModule,
        SelectModule,
        FileUploadModule,
        CardModule,
        DividerModule,
        TabsModule,
        ProgressBarModule,
        AccordionModule,
        ToastModule,
        ConfirmPopupModule,
        ToggleSwitchModule,
        CheckboxModule,
        IconFieldModule,
        InputIconModule,
        InputTextModule,
        DialogModule,
        ListboxModule,
    ],
    imports: [
        AngularMultiSelectModule,
        DropDownsModule,
        FormsModule,
        InputsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatCheckboxModule,
        MatButtonModule,
        MatRadioModule,
        MatListModule,
        MatMenuModule,
        MatRippleModule,
        MatSelectModule,
        MatSliderModule,
        MatDialogModule,
        MatSnackBarModule,
        MatChipsModule,
        MatInputModule,
        MatDividerModule,
        MatGridListModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatAutocompleteModule,
        MatExpansionModule,
        MatSidenavModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        GridModule,
        TooltipModule,
        ExcelModule,
        DateInputsModule,
        PDFModule,
        NgxPaginationModule,
        DragulaModule.forRoot(),
        CurrencyMaskModule,
        AvatarModule,
        LabelModule,
        ButtonModule,
        MultiSelectModule,
        SelectModule,
        FileUploadModule,
        CardModule,
        DividerModule,
        TabsModule,
        ProgressBarModule,
        AccordionModule,
        ToastModule,
        ConfirmPopupModule,
        ToggleSwitchModule,
        CheckboxModule,
        IconFieldModule,
        InputIconModule,
        InputTextModule,
        DialogModule,
        ListboxModule,
    ],
    providers: [
        { provide: MAT_DIALOG_DATA, useFactory: () => [MatDialogRef] },
        MatDatepickerModule,
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class ThirdPartyModule {}
